export interface Audit {
  activityLogId: number;
  actionPerformedOnName: string;
  actionPerformedOnConsumerId: number;
  auditDate: string;
  actionId: number;
  actionName: string;
  accessTypeRecord: string;
  accessTypeId: number;
  activityLog: string;
  actionPerformedBy: string;
  description: string;
  transmittedTo: string;
  categoryId: number;
  categoryLabel: string;
}

export interface Persons {
  key: string;
  value: string;
}

export interface AuditPageState {
  string: {
    data: Audit[];
  };
}

export enum AuditFilterTitles {
  categories = 'Data Category',
  actions = 'Action',
  persons = 'Performed On',
  dateAndTimeOfEvents = 'Date Range',
  lastTirtyDays = 'Last 30 Days',
  lastNintyDays = 'Last 90 Days',
  lastThreeSixtyDays = 'Last 360 Days',
  customDateRange = 'Custom Date Range',
  performedBy = 'Performed By'
}

export enum AuditLogFacetGroups {
  categories = 'categories', // Filter Audit logs by categories
  actions = 'actions', // Filter Audit logs by actions
  persons = 'persons', // Filter Audit logs by categories
  dateAndTimeOfEvents = 'dateAndTimeOfEvents',
  performedBy = 'performedBy'
}

export enum AuditLogFilterGroups {
  categories = 'categories', // Filter Audit logs by categories
  actions = 'actions', // Filter Audit logs by actions
  persons = 'persons', // Filter Audit logs by categories
  dateAndTimeOfEvents = 'dateAndTimeOfEvents',
  performedBy = 'performedBy'
}

export interface AuditFilter {
  title?: string;
  group: AuditLogFacetGroups;
  value: boolean;
}

export interface AuditFacet {
  title?: string;
  group: AuditLogFacetGroups;
  value: boolean | string;
}

export interface AuditLogOptions {
  page?: number;
  limit?: number;
  orderBy?: string;
  input?: string;
  startsAt?: string | Date;
  endsAt?: string | Date;
  filters?: AuditFilter[];
  facets?: AuditFacet[];
}

export interface AuditData {
  comment: string;
  targetURL: string;
  actionId: string;
  mmiNumber: string;
  accessType: string;
  mobileDeviceId: string;
  accessRecord: string;
}

export enum AuditActionIds {
  INSERT = '1',
  READ = '2',
  UPDATE = '3',
  DELETE = '4',
  LOGOFF = '5',
  SUCCESSFUL_LOGON = '6',
  UNSUCCESSFUL_LOGON = '7',
  MAX_LOGIN_ATTEMPTS_REACHED = '8',
  SUCCESSFUL_CHALLENGE_ANSWER = '9',
  UNSUCCESSFUL_CHALLENGE_ANSWER = '10',
  MAX_CHALLENGE_ANSWER_REACHED = '11',
  CHANGE_PASSWORD = '33',
  CHANGE_CHALLENGE_ANSWER = '34',
  SEND = '19216',
  CANCEL = '19217',
  NO_ACTION = '80757',
  BEGIN_PROXY = '88',
  END_PROXY = '89',
  PRINTED = '12',
  DOWNLOAD = '15',
  FAILED_REGISTRATION = '95',
  SUCCESSFUL_PROXY = '96',
  FAILED_PROXY = '97',
  REJECTED_TERMS = '98',
  SUCCESSFUL_REGISTRATION = '94',
  ACCEPTED_TERMS = '99',
  EMAIL_RECEIVED = '65',
  EMAIL_SENT = '66'
}

export enum AuditAccessTypes {
  MILLENNIUM = '10',
  PING = '15',
  AMWELL = '20',
  IDDATAWEB = '25',
  R1 = '30',
  CHANGE_HEALTHCARE = '35',
  CDR = '38',
  SELECTHEALTH = '160'
}

export enum AuditCategory {
  UNKNOWN = '0',
  VISIT_SUMMARIES = '1',
  TEST_RESULTS = '2',
  MEDICATION_LIST = '3',
  MEDICAL_HISTORY = '4',
  VITALS = '5',
  MESSAGES = '6',
  BILLING = '7',
  MY_ACCOUNT = '8',
  AUDIT_LOG = '9',
  CLINICAL_NOTES_AND_DOCUMENTATION = '10',
  HEALTH_RECORD_SUMMARY = '11',
  GOALS = '12',
  AMWELLAUTH = '13',
  NOTIFICATION = '14',
  'DFD-FHIR-BINARY' = '15',
  BOOKING = '16',
  IDENTIFY = '17'
}

export enum AuditAccessRecord {
  HEALTH_RECORD_SERVICE = 'health-record-service'
}
